import { render, staticRenderFns } from "./shanghaiEco.vue?vue&type=template&id=07b65a22&scoped=true&"
import script from "./shanghaiEco.vue?vue&type=script&lang=js&"
export * from "./shanghaiEco.vue?vue&type=script&lang=js&"
import style0 from "./shanghaiEco.vue?vue&type=style&index=0&id=07b65a22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b65a22",
  null
  
)

export default component.exports